import { NgModule } from '@angular/core';

import {
  FunctionalTranspiler,
  provideTransloco,
  provideTranslocoTranspiler,
  TranslocoModule,
} from '@jsverse/transloco';
import { TranslocoHttpLoader } from './transloco-loader';

@NgModule({
  exports: [TranslocoModule],
  providers: [
    provideTranslocoTranspiler(FunctionalTranspiler),
    provideTransloco({
      config: {
        availableLangs: ['fr'],
        defaultLang: 'fr',
        // Remove this option if your application doesn't support changing language in runtime.
        reRenderOnLangChange: true,
        //prodMode: environment.production,
      },
      loader: TranslocoHttpLoader,
    }),
  ],
})
export class TranslocoRootModule {}
